
import BaseNativeAppContainer from '../base-native-app-container/BaseNativeAppContainer';
import { FILE_EXPLORER_CONTENT_TYPE } from '../../constants/constants';
import Styles from './ContentDialog.module.scss';
import classnames from "classnames"
import { ReactComponent as LeftIcon } from "../../icons/extra_icons/left.svg"
import { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import BaseMobileAppContainer from '../mobile/base-mobile-app-container/BaseMobileAppContainer';
import { getFileExtension, getFileTypeIcon } from '../file-explorer/content-box/ContentBox';
import { getCurrentOption, gotoPreviousOption } from '../../global/functions/functrions';
import Loader from '../loader/Loader';

interface ContentDialogProps {
    appId: string;
    title: string;
    loadFromX?: number;
    loadFromY?: number;
    sourceLink: string;
    isPreviousIconVisible?: boolean;
    isNextIconVisible?: boolean;
    fileType: FILE_EXPLORER_CONTENT_TYPE.FOLDER | FILE_EXPLORER_CONTENT_TYPE.IMAGE | FILE_EXPLORER_CONTENT_TYPE.PDF | FILE_EXPLORER_CONTENT_TYPE.VIDEO | FILE_EXPLORER_CONTENT_TYPE.WORD;
    onPreviousClick?: (data?: any) => void;
    onNextClick?: (data?: any) => void;
    onClosedSuccessfully?: (id: any, index: number | undefined) => void;
}

const ContentDialog = ({
    appId,
    title,
    loadFromX = 400,
    loadFromY = 400,
    fileType,
    sourceLink,
    isPreviousIconVisible = false,
    isNextIconVisible = false,
    onPreviousClick,
    onNextClick,
    onClosedSuccessfully
}: ContentDialogProps) => {

    const { isMobile } = useContext(AppContext)

    const getFileView = () => {
        switch (fileType) {
            case FILE_EXPLORER_CONTENT_TYPE.IMAGE: return <img src={sourceLink} />
            default: return <iframe className={Styles.file_frame} src={sourceLink} ></iframe>
        }
    }

    return (
        <>
            {
                isMobile ? (
                    <BaseMobileAppContainer
                        appId={appId}
                        title={title}
                        MainScreen={
                            <div className={Styles.file_container}>
                                <div className={Styles.loader}>
                                    <Loader/>
                                </div>
                                <div className={Styles.header}>
                                    <div className={Styles.icon}>
                                        {getFileTypeIcon(fileType, isMobile)}
                                    </div>
                                    <div className={Styles.label}>
                                        {title}
                                    </div>
                                </div>
                                <div className={Styles.file}>
                                    {getFileView()}
                                </div>
                                {
                                    onPreviousClick && onNextClick && (
                                        <div className={Styles.buttons}>
                                            {
                                                isPreviousIconVisible ?
                                                    <div className={Styles.button}>
                                                        <LeftIcon onClick={onPreviousClick} />
                                                    </div>
                                                    : <div></div>
                                            }
                                            {
                                                isNextIconVisible && <div className={classnames(Styles.button, Styles.flip)}>
                                                    <LeftIcon onClick={onNextClick} />
                                                </div>
                                            }
                                        </div>
                                    )
                                }
                            </div>
                        }
                        isMainScreenActive={true}
                        onClosedSuccessfully={() => { onClosedSuccessfully?.("", undefined) }}
                    />
                ) : (
                    <BaseNativeAppContainer
                        appId={appId}
                        width={900}
                        loadFromX={loadFromX}
                        loadFromY={loadFromY}
                        title={title}
                        MainScreen={
                            <div className={Styles.file_container}>
                                <div className={Styles.loader}>
                                    <Loader/>
                                </div>
                                <div className={Styles.file}>
                                    {getFileView()}
                                </div>
                                {
                                    onPreviousClick && onNextClick && (
                                        <div className={Styles.buttons}>
                                            {
                                                isPreviousIconVisible ?
                                                    <div className={Styles.button}>
                                                        <LeftIcon onClick={onPreviousClick} />
                                                    </div>
                                                    : <div></div>
                                            }
                                            {
                                                isNextIconVisible && <div className={classnames(Styles.button, Styles.flip)}>
                                                    <LeftIcon onClick={onNextClick} />
                                                </div>
                                            }
                                        </div>
                                    )
                                }

                            </div>
                        }
                        onClosedSuccessfully={() => { onClosedSuccessfully?.("", undefined) }}
                    />
                )
            }
        </>
    )
}

export default ContentDialog
